import { gql, useQuery } from '@apollo/client';
import {
  BrandKey,
  CategoryFormat,
  GetBrandKeysQuery,
  GetBrandKeysQueryVariables,
} from '__generated__/queries-web';

export const GET_BRANDKEYS = gql`
  query GetBrandKeys($first: UnsignedInt!, $where: CategoryFilterInput) {
    categories(where: $where, first: $first) {
      id
      brandKey
    }
  }
`;

export const useGetBrandKeys = (skip?: boolean) =>
  useQuery<GetBrandKeysQuery, GetBrandKeysQueryVariables>(GET_BRANDKEYS, {
    variables: {
      first: 100,
      where: {
        level: 2,
        format: CategoryFormat.Category,
        brandKey_in: [BrandKey.CAC, BrandKey.FAC, BrandKey.VOI],
      },
    },
    skip,
  });
